<template>
  <div id="expensesPayableComponent">
    <page-title
      :heading="heading"
      :subheading="subheading"
      :icon="icon"
    ></page-title>
    <v-container>
      <v-layout class="mb-2" row wrap>
         <v-flex class="text-sm-right" xs2 sm2>
            <v-menu v-model="menuP" ref="menu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="startDate" :label="$t('employerReports.startDate')" prepend-icon="event" readonly v-on="on"></v-text-field>
              </template>
              <v-date-picker color="primary" v-model="startDate" @input="menu = false" :max="today" :locale="$t('reportsType.local')" @change="limiteRangeDay()">
                <v-spacer></v-spacer>
              </v-date-picker>
            </v-menu>
        </v-flex>
        <v-flex class="text-sm-right" xs2 sm2>
          <v-menu ref="menu2" v-model="menuP2" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
            <template v-slot:activator="{ on }">
              <v-text-field v-model="endDate" :label="$t('employerReports.endDate')" prepend-icon="event" readonly v-on="on"></v-text-field>
            </template>
            <v-date-picker color="primary" v-model="endDate" :min="startDate" :locale="$t('reportsType.local')" @input="menu = false" @change="limiteRangeDayEndDate()">
              <v-spacer></v-spacer>
            </v-date-picker>
          </v-menu>
        </v-flex>
        <v-btn color="primary" icon @click="searchByDates()">
          <v-icon>search</v-icon>
        </v-btn>
        <v-flex class="text-xs-right">
          <v-dialog v-model="dialogApprobed" max-width="600px" persistent>
            <v-card>
              <v-toolbar flat>
                <h2 class="font-weight-black primary--text mb-0">
                  {{ $t('ExpensesPayable.paymentAmount') }}
                </h2>
              </v-toolbar>
              <v-card-text>
                <v-container grid-list-xs>
                  <v-layout>
                    <v-flex xs12>
                      <h3>{{ $t('ExpensesPayable.selectAmount') }}.</h3>
                      <br />
                      <h3>
                        <span class="font-weight-black primary--text">{{ $t('general.description') }}:</span>
                        {{ approbed.description }}
                      </h3>
                      <h3>
                        <span class="font-weight-black primary--text">{{ $t('ExpensesPayable.amountToPay') }}:</span>
                        {{ approbed.is_blue_voucher ? (Math.abs(approbed.voucher_amount)) : Math.abs(approbed.repay_back) | formatCurrency }}
                      </h3>
                      <h3 v-if="approbed.payments">
                        <span class="font-weight-black primary--text">{{ $t('ExpensesPayable.remaining') }}:</span>
                        {{ toPay(approbed) | formatCurrency }}
                      </h3>
                    </v-flex>
                  </v-layout>
                  <br />
                  <v-form lazy-validation ref="form" v-model="valid">
                    <v-layout justify-content-end row wrap>
                      <v-flex xs12>
                        <v-text-field
                          type="number"
                          clearable
                          required
                          :disabled="disabled"
                          prepend-icon="attach_money"
                          :rules="rules.required && rules.decimal"
                          :label="$t('restriction.rt.amount')"
                          v-model="editedItem.payment"
                          @keyup.enter="payExpenses(approbed)"
                        >
                        </v-text-field>
                      </v-flex>
                      <v-flex xs4>
                        <v-checkbox
                          color="primary"
                          v-model="payComplete"
                          label="Pagar completo"
                        ></v-checkbox>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" round flat @click="close">
                  {{ $t('general.cancel') }}
                </v-btn>
                <v-btn color="primary" round class="white--text" depressed :loading="loading" :disabled="loading" @click="payExpenses(approbed)">
                  {{ $t('general.pay') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogPayment" max-width="500px" persistent>
            <v-card>
              <v-toolbar flat>
                <h2 class="font-weight-black primary--text mb-0">
                  {{ $t('workflowValidation.confirmAp') }}
                </h2>
              </v-toolbar>
              <v-card-text>
                <v-container grid-list-xs>
                  <h3>
                    <p>
                      {{ $t('ExpensesPayable.confirmPayment') }}
                      {{ approbed.id }}?
                    </p>
                    <p class="font-weight-black">
                      <span class="primary--text"
                        >{{ $t('general.user') }}:</span
                      >
                      {{ approbed.user.name }}.
                    </p>
                  </h3>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" round flat @click="close">
                  {{ $t('general.cancel') }}
                </v-btn>
                <v-btn
                  color="primary"
                  round
                  class="white--text"
                  depressed
                  :loading="loading"
                  :disabled="loading"
                  @click="changePaid(approbed)"
                >
                  {{ $t('ExpensesPayable.paid') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogPayMultipleExpenses" max-width="600px" persistent>
            <v-card>
              <v-toolbar flat>
                <h2 class="font-weight-black primary--text mb-0">
                  {{ $t('general.payGenerateLayout') }}
                </h2>
              </v-toolbar>
              <v-card-text>
                <v-container grid-list-xs>
                  <v-flex xs12>
                    <h3>{{ $t('ExpensesPayable.descriptionPayMultipleExpense') }}.</h3>
                  </v-flex>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" round flat @click="dialogPayMultipleExpenses = false">
                  {{ $t('general.cancel') }}
                </v-btn>
                <v-btn color="primary" round class="white--text" depressed :loading="loading" :disabled="loading" @click="payMultipleExpenses()">
                  {{ $t('general.payGenerateLayout') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
        <v-spacer></v-spacer>
        <v-text-field type="number" v-model="searchExpensesId" @keydown.enter="searchByExpensesId()" min="0" :label="$t('expenses.idExpenseSearch')"></v-text-field>
        <v-btn :hidden="hiddenDownloadLayout" @click="downloadLayout" :loading="loadingDownload" slot="activator" color="primary" round outline>
            <v-icon left>download</v-icon>
            {{ $t('general.downloadLayout') }}
        </v-btn>
        <v-btn :hidden="hiddenPayGenerateLayout" @click="dialogPayMultipleExpenses = true" slot="activator" color="primary" round outline>
            <v-icon left>download</v-icon>
            {{ $t('general.payGenerateLayout') }}
        </v-btn>
        <v-btn v-if="applyFeatures" @click="createLayout" slot="activator" color="primary" round outline>
          <v-icon left>add_circle</v-icon>
          {{ $t('general.generateLayoutBank') }}
        </v-btn>
        <v-menu v-if="applyFeaturesBtnERP" offset-y>
          <template v-slot:activator="{ on }">
            <v-btn color="primary"  v-on="on" round outline>
              <v-icon left>menu</v-icon> {{nameInput}}
            </v-btn>
          </template>
          <v-list>
            <v-list-tile @click="createLayoutERP(1)">
              <v-list-tile-avatar>
                <v-icon left>add_circle</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-title>{{ $t('general.generateLayoutERP') }}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="createLayoutERP(2)">
              <v-list-tile-avatar>
                <v-icon left>add_circle</v-icon>
              </v-list-tile-avatar>
            <v-list-tile-title>{{ $t('general.payGenerateLayout') }}</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="dialogDownloadLayoutByExpenseM()">
              <v-list-tile-avatar>
                <v-icon left>add_circle</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-title>{{$t('general.layoutList')}}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
        <v-btn v-if="applyFeaturesBtnHelperXml" @click="createLayoutHelperXml" slot="activator" color="primary" round outline>
          <v-icon left>add_circle</v-icon>
          {{ $t('general.generateLayoutHelperXml') }}
        </v-btn>
        <!-- AGREGADO TEMPORALMENTE PARA PRODUCCIÓN -->
        <!-- <v-btn v-if="viewSelectedExpense" @click="selectMultipleExpense" slot="activator" color="primary" round outline>
          <v-icon left>add_circle</v-icon>
          {{ $t('expenses.selectExpense') }}
        </v-btn>
        <v-btn v-else @click="payExpensesMultiple" slot="activator" color="primary" round outline>
          <v-icon left>add_circle</v-icon>
          {{ $t('ExpensesPayable.payExpensesMultiples') }}
        </v-btn> -->
      </v-layout>
      <b-tabs ref="myTabs" pills active-nav-item-class="primary">
        <b-tab @click="handleTabChange('myApprovals')" title="myApprovals" :key="'myApprovals'">
          <template variant="primary" v-slot:title>
            <h5 class="my-0">{{$t('ExpensesPayable.myApprovals')}}</h5>
          </template>
          <v-flex>
            <v-toolbar flat color="bg-sidebar" dark>
              <h2 class="my-0">{{$t('ExpensesPayable.myApprovals')}}</h2>
              <v-spacer></v-spacer>
              <v-text-field color="light" v-model="expensePayableSearch" :label="$t('general.filter')"></v-text-field>
            </v-toolbar>
            <v-data-table
              :search="expensePayableSearch"
              class="elevation-2"
              :headers="headers"
              :items="expenses"
              :loading="loadingDataTable"
              :rows-per-page-items="[10, 15, 25]"
              :pagination.sync="pagination"
              :expand="expand">
            <template v-slot:headers="props">
              <tr class="bg-heavy-rain">
                <!-- CHECK ALL -->
                <th style="padding: 1px 15px 10px !important; margin: 1px !important;">
                  <v-checkbox
                    class="justify-center align-center"
                    :input-value="allChecked"
                    :hidden="hiddenCheck"
                    color="primary"
                    hide-details
                    @click.stop="toggleAll('expenses', allChecked)">
                  </v-checkbox>
                </th>
                <th v-for="header in props.headers"
                  :key="header.text"
                  :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                  @click="changeSort(header.value)">
                  <h2 class="font-weight-black primary--text mb-0 d-flex align-center">
                    <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
                    <span>{{ header.text }}</span>
                  </h2>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <!-- CHECK ALL -->
                <td colspan="2" class="">
                  <div class="d-flex align-center">
                    <v-checkbox 
                      :hidden="hiddenCheck" 
                      :input-value="props.item.isChecked" 
                      @change="toggleItem(props.item, 'expenses')" 
                      class="mr-2"
                    ></v-checkbox>
                    <span>{{ props.item.id }}</span>
                  </div>
                  <div v-if="props.item.gst_expenses_status_id === 4 && (props.item.petty_cash_type === 1 || props.item.petty_cash_type === 2)">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-chip v-on="on" color="info" class="font-weight-black" dark small>{{ props.item.petty_cash_type === 1 ? $t('pettyCash.title') : $t('amexCard.title') }}</v-chip>
                      </template>
                      <span class="font-weight-black" >{{ props.item.petty_cash_type === 1 ? $t('pettyCash.title') : $t('amexCard.title') }}: {{ props.item.user.small_box.amount | formatCurrency }} MXN</span>
                    </v-tooltip>
                  </div>
                  <div v-if=" props.item.gst_expenses_status_id === 4 && props.item.petty_cash_type === 0">
                    <v-chip  class="font-weight-black" small>{{$t('notifications.pending')}}</v-chip>
                  </div>
                  <div v-if="props.item.gst_expenses_status_id === 5">
                    <v-menu open-on-hover offset-y bottom transition="slide-y-transition">
                      <template v-slot:activator="{ on }">
                        <v-chip small class="font-weight-black" color="warning lighten-2" v-on="on" >{{ $t('general.incomplete') }}</v-chip>
                      </template>
                      <v-card>
                        <v-subheader>
                          <span class="font-weight-black primary--text" >{{ $t('general.paymentsMade') }}:</span>
                        </v-subheader>
                        <v-list>
                          <v-list-tile class="mb-0" v-for="pay in props.item.payments" :key="pay.id">
                            <v-list-tile-content>
                              <v-list-tile-sub-title>
                                <div class="mb-2 mr-2 badge badge-dot badge-dot-sm badge-primary">Primary</div>
                                <span class="font-weight-black">{{ pay.amount | formatCurrency }}</span> - {{ pay.created_at }}</v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-list>
                      </v-card>
                    </v-menu>
                  </div>
                </td>
                <td @click="deployRow(props)" class="text-sm-center">{{ props.item.user.name }}</td>
                <td @click="deployRow(props)" class="text-sm-center">{{ props.item.description }}</td>
                <td @click="deployRow(props)" class="text-sm-center">{{ props.item.project.name }}</td>
                <td @click="deployRow(props)" class="text-sm-center">{{ props.item.start_date }} / {{ props.item.end_date }}</td>
                <td v-if="props.item.petty_cash_type === 1 || props.item.petty_cash_type === 2" @click="deployRow(props)" class="text-sm-center">
                  <v-chip small class="font-weight-black">
                    {{ Math.abs(props.item.repay_back) | formatCurrency }}
                  </v-chip>
                </td>
                <td v-if="props.item.petty_cash_type === 0" @click="deployRow(props)" class="text-sm-center">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-chip small class="font-weight-black" :color=" props.item.repay_back < 0 ? 'bg-danger' : 'bg-success' " dark v-on="on"> {{ Math.abs(props.item.repay_back) | formatCurrency }} </v-chip>
                    </template>
                    <span>{{ payback(props.item.repay_back) }}</span>
                  </v-tooltip>
                </td>
                <td @click="deployRow(props)" class="text-sm-center">${{ props.item.advance }}</td>
                <td @click="deployRow(props)" class="text-sm-center">${{ props.item.total_items[0].sumtotal_mxn }}</td>
                <td>
                  <v-btn small v-if="props.item.repay_back < 0 && props.item.petty_cash_type === 0" block outline color="primary" round @click="viewNewItemsApprobed(props.item)">{{ $t('general.pay') }}</v-btn>
                  <v-btn small v-if="props.item.repay_back >= 0 || (props.item.petty_cash_type === 1 || props.item.petty_cash_type === 2)" block outline color="primary" round @click="paymentApprove(props.item)">{{ $t('ExpensesPayable.paid') }}</v-btn>
                </td>
              </tr>
            </template>
            <template v-slot:expand="props">
              <v-card color="grey lighten-4" flat>
                <v-layout>
                  <v-flex xs12>
                    <h2 class="primary--text text-sm-left ml-3 mt-2">
                      {{ $t('general.expenseItems') }}:
                    </h2>
                  </v-flex>
                </v-layout>
                <v-layout v-if="props.item.gst_expenses_items.length === 0">
                  <v-flex xs12>
                    <p class="text-sm-left ml-4">{{ $t('history.noItem') }}</p>
                  </v-flex>
                </v-layout>
                <v-layout v-if="props.item.gst_expenses_items.length !== 0">
                  <v-flex xs12>
                    <table width="100%">
                      <thead>
                        <th class="text-sm-center font-weight-black">#</th>
                        <th class="text-sm-center font-weight-black"> {{ $t('general.description') }} </th>
                        <th class="text-sm-center font-weight-black"> {{ $t('general.subtotal') }} </th>
                        <th class="text-sm-center font-weight-black"> {{ $t('general.total') }} {{ tagMoneda }} </th>
                        <th class="text-sm-center font-weight-black"> {{ $t('general.comment') }} </th>
                        <th class="text-sm-center font-weight-black"> {{ $t('general.actions') }} </th>
                      </thead>
                      <tr v-for="item of props.item.gst_expenses_items" :key="item.id">
                        <td class="text-sm-center">{{ item.id }}</td>
                        <td class="text-sm-center">{{ item.description }}</td>
                        <td class="text-sm-center">{{ item.subtotal | formatCurrency }} ({{ currencyTag(item.currency) }})</td>
                        <td class="text-sm-center">{{ getTotalAmountByExpense(item) | formatCurrency }}</td>
                        <td class="text-sm-center">{{ item.comment }}</td>
                        <td class="text-sm-center">
                          <v-btn small outline round color="primary" icon @click="itemExpenseDialog(item)" :disabled="loading" :loading="loading"><v-icon small>search</v-icon></v-btn>
                        </td>
                      </tr>
                    </table>
                  </v-flex>
                </v-layout>
              </v-card>
            </template>
            </v-data-table>
          </v-flex>
        </b-tab>
        <b-tab v-if="viewBtnOthers" @click="handleTabChange('others')" title="others" :key="'others'">
          <template  variant="primary"  v-slot:title >
            <h5 class="my-0">{{$t('general.others')}}</h5>
          </template>
          <v-flex>
            <v-toolbar flat color="bg-sidebar" dark>
              <h2 class="my-0">{{$t('general.others')}}</h2>
              <v-spacer></v-spacer>
              <v-text-field color="light" v-model="expensePayableOthersSearch" :label="$t('general.filter')"></v-text-field>
            </v-toolbar>
            <v-data-table
              :search="expensePayableOthersSearch"
              class="elevation-2"
              :headers="headers"
              :items="expensesOthers"
              :loading="loadingDataTableOthers"
              :rows-per-page-items="[10, 15, 25]"
              :pagination.sync="pagination"
              :expand="expand">
            <template v-slot:headers="props">
              <tr class="bg-heavy-rain">
                <!-- CHECK ALL -->
                <th style="padding: 1px 15px 10px !important; margin: 1px !important;">
                  <v-checkbox
                    class="justify-center align-center"
                    :input-value="allChecked"
                    :hidden="hiddenCheck"
                    color="primary"
                    hide-details
                    @click.stop="toggleAll('expensesOthers', allChecked)">
                  </v-checkbox>
                </th>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column',
                    header.sortable ? 'sortable' : '',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                  ]"
                  @click="changeSort(header.value)"
                >
                  <h2 class="font-weight-black primary--text mb-0">
                    <v-icon small class="primary--text" v-if="header.sortable"
                      >arrow_upward</v-icon
                    >
                    {{ header.text }}
                  </h2>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <!-- CHECK ALL -->
                <td colspan="2">
                  <div class="d-flex align-center">
                    <v-checkbox
                      :hidden="hiddenCheck"
                      :input-value="props.item.isChecked"
                      @change="toggleItem(props.item, 'expensesOthers')"
                      class="mr-2"
                    ></v-checkbox>
                    <span>{{ props.item.id }}</span>
                  </div>
                  <div v-if="props.item.gst_expenses_status_id === 4 && (props.item.petty_cash_type === 1 || props.item.petty_cash_type === 2)">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                      <v-chip v-on="on" color="info" class="font-weight-black" dark small>{{ props.item.petty_cash_type === 1 ? $t('pettyCash.title') : $t('amexCard.title') }}</v-chip>
                      </template>
                      <span class="font-weight-black" >{{ props.item.petty_cash_type === 1 ? $t('pettyCash.title') : $t('amexCard.title') }}: {{ props.item.user.small_box.amount | formatCurrency }} MXN</span>
                    </v-tooltip>
                  </div>
                  <div v-if="props.item.gst_expenses_status_id === 4 && props.item.petty_cash_type === 0">
                    <v-chip  class="font-weight-black" small>{{$t('notifications.pending')}}</v-chip>
                  </div>
                  <div v-if="props.item.gst_expenses_status_id === 5">
                    <v-menu  open-on-hover offset-y bottom transition="slide-y-transition">
                      <template v-slot:activator="{ on }">
                        <v-chip small class="font-weight-black" color="warning lighten-2" v-on="on" >{{ $t('general.incomplete') }}</v-chip>
                      </template>
                      <v-card>
                        <v-subheader>
                          <span class="font-weight-black primary--text">{{ $t('general.paymentsMade') }}:</span>
                        </v-subheader>
                        <v-list>
                          <v-list-tile class="mb-0" v-for="pay in props.item.payments" :key="pay.id">
                            <v-list-tile-content>
                              <v-list-tile-sub-title>
                                <div class=" mb-2 mr-2 badge badge-dot badge-dot-sm badge-primary"> Primary </div>
                                <span class="font-weight-black">{{ pay.amount | formatCurrency }}</span> - {{ pay.created_at }}</v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-list>
                      </v-card>
                    </v-menu>
                  </div>
                </td>
                <td @click="deployRow(props)" class="text-sm-center">
                  {{ props.item.user.name }}
                </td>
                <td @click="deployRow(props)" class="text-sm-center">
                  {{ props.item.description }}
                </td>
                <td @click="deployRow(props)" class="text-sm-center">
                  {{ props.item.project.name }}
                </td>
                <td @click="deployRow(props)" class="text-sm-center">
                  {{ props.item.start_date }} / {{ props.item.end_date }}
                </td>
                <td v-if="props.item.is_blue_voucher === 1" @click="deployRow(props)" class="text-sm-center">
                  <v-chip small class="font-weight-black">
                    {{ Math.abs(props.item.voucher_amount) | formatCurrency }}
                  </v-chip>
                </td>
                <td v-if="(props.item.petty_cash_type === 1 || props.item.petty_cash_type === 2) && props.item.is_blue_voucher === 0" @click="deployRow(props)" class="text-sm-center">
                  <v-chip small class="font-weight-black">
                    {{ Math.abs(props.item.repay_back) | formatCurrency }}
                  </v-chip>
                </td>
                <td v-if="props.item.petty_cash_type === 0 && props.item.is_blue_voucher === 0" @click="deployRow(props)" class="text-sm-center">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-chip small class="font-weight-black" :color="props.item.repay_back < 0 ? 'bg-danger' : 'bg-success'" dark v-on="on">
                        {{ Math.abs(props.item.repay_back) | formatCurrency }}
                      </v-chip>
                    </template>
                    <span>{{ payback(props.item.repay_back) }}</span>
                  </v-tooltip>
                </td>
                <td @click="deployRow(props)" class="text-sm-center">
                  ${{ props.item.advance }}
                </td>
                <td @click="deployRow(props)" class="text-sm-center">
                  ${{ props.item.total_items[0].sumtotal_mxn }}
                </td>
                <td>
                  <v-btn
                    small
                    v-if="
                      props.item.repay_back < 0 && props.item.petty_cash_type === 0
                    "
                    block
                    outline
                    color="primary"
                    round
                    @click="viewNewItemsApprobed(props.item)"
                    >{{ $t('general.pay') }}</v-btn
                  >
                  <v-btn
                    small
                    v-if="
                      props.item.repay_back >= 0 || (props.item.petty_cash_type === 1 || props.item.petty_cash_type === 2)
                    "
                    block
                    outline
                    color="primary"
                    round
                    @click="paymentApprove(props.item)"
                    >{{ $t('ExpensesPayable.paid') }}</v-btn
                  >
                </td>
              </tr>
            </template>
            <template v-slot:expand="props">
              <v-card color="grey lighten-4" flat>
                <v-layout>
                  <v-flex xs12>
                    <h2 class="primary--text text-sm-left ml-3 mt-2">
                      {{ $t('general.expenseItems') }}:
                    </h2>
                  </v-flex>
                </v-layout>
                <v-layout v-if="props.item.gst_expenses_items.length === 0">
                  <v-flex xs12>
                    <p class="text-sm-left ml-4">{{ $t('history.noItem') }}</p>
                  </v-flex>
                </v-layout>
                <v-layout v-if="props.item.gst_expenses_items.length !== 0">
                  <v-flex xs12>
                    <table width="100%">
                      <thead>
                        <th class="text-sm-center font-weight-black">#</th>
                        <th class="text-sm-center font-weight-black">
                          {{ $t('general.description') }}
                        </th>
                        <th class="text-sm-center font-weight-black">
                          {{ $t('general.subtotal') }}
                        </th>
                        <th class="text-sm-center font-weight-black">
                          {{ $t('general.total') }} {{ tagMoneda }}
                        </th>
                        <th class="text-sm-center font-weight-black">
                          {{ $t('general.comment') }}
                        </th>
                        <th class="text-sm-center font-weight-black">
                          {{ $t('general.actions') }}
                        </th>
                      </thead>
                      <tr
                        v-for="item of props.item.gst_expenses_items"
                        :key="item.id"
                      >
                        <td class="text-sm-center">{{ item.id }}</td>
                        <td class="text-sm-center">{{ item.description }}</td>
                        <td class="text-sm-center">{{ item.subtotal | formatCurrency }} ({{ currencyTag(item.currency) }})</td>
                        <td class="text-sm-center">{{ getTotalAmountByExpense(item) | formatCurrency }}</td>
                        <td class="text-sm-center">{{ item.comment }}</td>
                        <td class="text-sm-center">
                          <v-btn
                            small
                            outline
                            round
                            color="primary"
                            icon
                            @click="itemExpenseDialog(item)"
                            :disabled="loading"
                            :loading="loading"
                          >
                            <v-icon small>search</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </table>
                  </v-flex>
                </v-layout>
              </v-card>
            </template>
            </v-data-table>
          </v-flex>
        </b-tab>
        <b-tab @click="handleTabChange('erpExportLog')" title="erpExportLog" :key="'erpExportLog'">
          <template variant="primary" v-slot:title>
            <h5 class="my-0">{{$t('general.erpExportLog')}}</h5>
          </template>
          <v-flex>
            <v-toolbar flat color="bg-sidebar" dark>
              <h2 class="my-0">{{$t('general.erpExportLog')}}</h2>
              <v-spacer></v-spacer>
              <v-text-field color="light" v-model="expensePayableErpExportLogSearch" :label="$t('general.filter')"></v-text-field>
            </v-toolbar>
            <v-data-table
              :search="expensePayableErpExportLogSearch"
              class="elevation-2"
              :headers="headers"
              :items="expensesExportLayout"
              :loading="loadingDataTableLayout"
              :rows-per-page-items="[10, 15, 25]"
              :pagination.sync="pagination"
              :expand="expand">
            <template v-slot:headers="props">
              <tr class="bg-heavy-rain">
                <!-- CHECK ALL -->
                <th style="padding: 1px 15px 10px !important; margin: 1px !important;">
                  <v-checkbox v-if="expenses.length <= 30"
                    class="justify-center align-center"
                    :input-value="allChecked"
                    :hidden="hiddenCheck"
                    color="primary"
                    hide-details
                    @click.stop="toggleAll('expensesExportLayout', allChecked)">
                  </v-checkbox>
                </th>
                <th v-for="header in props.headers"
                  :key="header.text"
                  :class="['column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                  @click="changeSort(header.value)">
                  <h2 class="font-weight-black primary--text mb-0 d-flex align-center">
                    <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
                    <span>{{ header.text }}</span>
                  </h2>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <!-- CHECK ALL -->
                <td colspan="2" class="">
                  <div class="d-flex align-center">
                    <v-checkbox
                      :hidden="hiddenCheck"
                      :input-value="props.item.isChecked"
                      @change="toggleItem(props.item, 'expensesExportLayout')"
                      class="mr-2"
                    ></v-checkbox>
                    <span>{{ props.item.id }}</span>
                  </div>
                  <div v-if="props.item.gst_expenses_status_id === 4 && (props.item.petty_cash_type === 1 || props.item.petty_cash_type === 2)" >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <v-chip v-on="on" color="info" class="font-weight-black" dark small>{{ props.item.petty_cash_type === 1 ? $t('pettyCash.title') : $t('amexCard.title') }}</v-chip>
                      </template>
                      <span class="font-weight-black" >{{ props.item.petty_cash_type === 1 ? $t('pettyCash.title') : $t('amexCard.title') }}: {{ props.item.user.small_box.amount | formatCurrency }} MXN</span>
                    </v-tooltip>
                  </div>
                  <div v-if=" props.item.gst_expenses_status_id === 4 && props.item.is_petty_cash === 0">
                    <v-chip  class="font-weight-black" small>{{$t('notifications.pending')}}</v-chip>
                  </div>
                  <div v-if="props.item.gst_expenses_status_id === 5">
                    <v-menu open-on-hover offset-y bottom transition="slide-y-transition">
                      <template v-slot:activator="{ on }">
                        <v-chip small class="font-weight-black" color="warning lighten-2" v-on="on" >{{ $t('general.incomplete') }}</v-chip>
                      </template>
                      <v-card>
                        <v-subheader>
                          <span class="font-weight-black primary--text" >{{ $t('general.paymentsMade') }}:</span>
                        </v-subheader>
                        <v-list>
                          <v-list-tile class="mb-0" v-for="pay in props.item.payments" :key="pay.id">
                            <v-list-tile-content>
                              <v-list-tile-sub-title>
                                <div class="mb-2 mr-2 badge badge-dot badge-dot-sm badge-primary">Primary</div>
                                <span class="font-weight-black">{{ pay.amount | formatCurrency }}</span> - {{ pay.created_at }}</v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>
                        </v-list>
                      </v-card>
                    </v-menu>
                  </div>
                </td>
                <td @click="deployRow(props)" class="text-sm-center">{{ props.item.user.name }}</td>
                <td @click="deployRow(props)" class="text-sm-center">{{ props.item.description }}</td>
                <td @click="deployRow(props)" class="text-sm-center">{{ props.item.project.name }}</td>
                <td @click="deployRow(props)" class="text-sm-center">{{ props.item.start_date }} / {{ props.item.end_date }}</td>
                <td v-if="(props.item.petty_cash_type === 1 || props.item.petty_cash_type === 2)" @click="deployRow(props)" class="text-sm-center">
                  <v-chip small class="font-weight-black">
                    {{ Math.abs(props.item.repay_back) | formatCurrency }}
                  </v-chip>
                </td>
                <td v-if="props.item.petty_cash_type === 0" @click="deployRow(props)" class="text-sm-center">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-chip small class="font-weight-black" :color=" props.item.repay_back < 0 ? 'bg-danger' : 'bg-success' " dark v-on="on"> {{ Math.abs(props.item.repay_back) | formatCurrency }} </v-chip>
                    </template>
                    <span>{{ payback(props.item.repay_back) }}</span>
                  </v-tooltip>
                </td>
                <td @click="deployRow(props)" class="text-sm-center">${{ props.item.advance }}</td>
                <td @click="deployRow(props)" class="text-sm-center">${{ props.item.total_items[0].sumtotal_mxn }}</td>
                <td>
                  <!-- AQUI -->
                  <v-btn small v-if="props.item.repay_back < 0 && props.item.petty_cash_type === 0" block outline color="primary" round @click="viewNewItemsApprobed(props.item)">{{ $t('general.pay') }}</v-btn>
                  <v-btn small v-if="props.item.repay_back >= 0 || (props.item.petty_cash_type === 1 || props.item.petty_cash_type === 2)" block outline color="primary" round @click="paymentApprove(props.item)">{{ $t('ExpensesPayable.paid') }}</v-btn>
                </td>
              </tr>
            </template>
            <template v-slot:expand="props">
              <v-card color="grey lighten-4" flat>
                <v-layout>
                  <v-flex xs12>
                    <h2 class="primary--text text-sm-left ml-3 mt-2">
                      {{ $t('general.expenseItems') }}:
                    </h2>
                  </v-flex>
                </v-layout>
                <v-layout v-if="props.item.gst_expenses_items.length === 0">
                  <v-flex xs12>
                    <p class="text-sm-left ml-4">{{ $t('history.noItem') }}</p>
                  </v-flex>
                </v-layout>
                <v-layout v-if="props.item.gst_expenses_items.length !== 0">
                  <v-flex xs12>
                    <table width="100%">
                      <thead>
                        <th class="text-sm-center font-weight-black">#</th>
                        <th class="text-sm-center font-weight-black"> {{ $t('general.description') }} </th>
                        <th class="text-sm-center font-weight-black"> {{ $t('general.subtotal') }} </th>
                        <th class="text-sm-center font-weight-black"> {{ $t('general.total') }} {{ tagMoneda }} </th>
                        <th class="text-sm-center font-weight-black"> {{ $t('general.comment') }}</th>
                        <th class="text-sm-center font-weight-black"> {{ $t('general.actions') }} </th>
                      </thead>
                      <tr v-for="item of props.item.gst_expenses_items" :key="item.id">
                        <td class="text-sm-center">{{ item.id }}</td>
                        <td class="text-sm-center">{{ item.description }}</td>
                        <td class="text-sm-center">{{ item.subtotal | formatCurrency }} ({{ currencyTag(item.currency) }})</td>
                        <td class="text-sm-center">{{ getTotalAmountByExpense(item) | formatCurrency }}</td>
                        <td class="text-sm-center">{{ item.comment }}</td>
                        <td class="text-sm-center">
                          <v-btn small outline round color="primary" icon @click="itemExpenseDialog(item)" :disabled="loading" :loading="loading"><v-icon small>search</v-icon></v-btn>
                        </td>
                      </tr>
                    </table>
                  </v-flex>
                </v-layout>
              </v-card>
            </template>
            </v-data-table>
          </v-flex>
        </b-tab>
      </b-tabs>
      <v-dialog persistent v-model="dialogDownloadLayoutByExpense" max-width="600px">
            <v-card>
              <v-toolbar flat>
                <h2 class="font-weight-black primary--text mb-0">{{$t('general.downloadLayoutByExpense')}}</h2>
              </v-toolbar>
              <v-card-text>
                <v-container grid-list-md>
                  <v-form v-model="valid" lazy-validation ref="form">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-combobox v-model="expensesIds" @paste.prevent="handlePaste" @keyup.enter.prevent="handleEnter()" :label="$t('general.addExpenseIdLayout')" :rules="rules.required" ref="combo" chips multiple required>
                          <template v-slot:selection="data">
                            <v-chip :selected="data.selected" @input="remove(data.item)" close>
                              <strong>{{ data.item }}</strong>&nbsp;
                            </v-chip>
                          </template>
                        </v-combobox>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="close" color="primary darken-1" round flat>
                  {{$t('general.close')}}
                </v-btn>
                <v-btn @click="downloadLayoutByExpense" :loading="loading" :disabled="!expensesIds.length > 0" color="primary" round depressed>
                  {{$t('general.submit')}}
                </v-btn>
              </v-card-actions>
            </v-card>
      </v-dialog>
      <v-dialog persistent v-model="itemDialog" max-width="600px" scrollable>
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black primary--text mb-0">
              {{ $t('expenseItems.description') }}
            </h2>
          </v-toolbar>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs6>
                  <p class="primary--text mb-0 text-sm-left">
                    <strong>{{ $t('general.date') }}</strong>
                  </p>
                  <p class="text-sm-left">{{ expenseItem.date }}</p>
                </v-flex>
                <v-flex xs6>
                  <p class="primary--text mb-0 text-sm-left">
                    <strong>{{ $t('general.category') }}</strong>
                  </p>
                  <p>{{ expenseItem.category }}</p>
                </v-flex>
                <v-flex xs6>
                  <p class="primary--text mb-0 text-sm-left">
                    <strong>{{ $t('general.country') }}</strong>
                  </p>
                  <p class="text-sm-justify">
                    {{ expenseItem.countryTag }}
                  </p>
                </v-flex>
                <v-flex xs6>
                  <p class="primary--text mb-0 text-sm-left">
                    <strong>{{ $t('general.isRefund') }}</strong>
                  </p>
                  <p class="text-sm-left">
                    {{
                      expenseItem.is_refund === 1
                        ? $t('general.yes')
                        : $t('general.no')
                    }}
                  </p>
                </v-flex>
                <v-flex xs12>
                  <p class="primary--text mb-0 text-sm-left">
                    <strong>{{ $t('general.description') }}</strong>
                  </p>
                  <p class="text-sm-left">{{ expenseItem.description }}</p>
                </v-flex>
                <v-flex xs6>
                  <p class="primary--text mb-0 text-sm-left">
                    <strong>{{ $t('general.currency') }}</strong>
                  </p>
                  <p class="text-sm-left">
                     {{ expenseItem.currencyTag }}
                  </p>
                </v-flex>
                <v-flex xs6>
                  <p class="primary--text mb-0 text-sm-left">
                    <strong>{{ $t('general.exchangeRate') }}</strong>
                  </p>
                  <p class="text-sm-left">{{ expenseItem.exchange }}</p>
                </v-flex>
                <v-flex xs6 v-if="expenseItem.gst_receipt_types_id === 3">
                  <p class="primary--text mb-0 text-sm-left">
                    <strong>{{ $t('general.supplier') }}</strong>
                  </p>
                  <p class="text-sm-left">{{ expenseItem.vendor ? expenseItem.vendor.name : ''}}</p>
                </v-flex>
                <v-flex xs6>
                  <p class="primary--text mb-0 text-sm-left">
                    <strong>{{ $t('general.subtotal') }}</strong>
                  </p>
                  <p class="text-sm-left">
                    ${{ expenseItem.subtotal }}
                  </p>
                </v-flex>
                <v-flex xs6>
                  <p class="primary--text mb-0 text-sm-left">
                    <strong>{{ $t('general.total') }} {{ tagMoneda }}</strong>
                  </p>
                  <p class="text-sm-left">
                    ${{ expenseItem.total }} {{ expenseItem.currency.c_Moneda }}
                  </p>
                </v-flex>
                <v-flex xs6>
                  <p class="primary--text mb-0 text-sm-left">
                    <strong>{{ $t('general.formaPago') }}</strong>
                  </p>
                  <p>{{expenseItem.paymentMethod}}</p>
                  <!-- <p class="text-sm-left">
                    {{ expenseItem.sat_forma_pago.descripcion }}
                  </p> -->
                </v-flex>
                <v-flex xs6>
                  <p class="primary--text mb-0 text-sm-left">
                    <strong>{{ $t('general.folioRef') }}</strong>
                  </p>
                  <p class="text-sm-left">{{ expenseItem.folio }}</p>
                </v-flex>
                <v-flex xs6>
                  <p class="primary--text mb-0 text-sm-left">
                    <strong>{{ $t('general.comment') }}</strong>
                  </p>
                  <p class="text-sm-justify">{{ expenseItem.comment }}</p>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div v-if="expenseItem.receipt_type">
              <v-btn
                color="success darken-1"
                round
                flat
                v-if="expenseItem.receipt_type.id == 1"
                :loading="loadingXML"
                @click="downloadXML"
              >
                {{ $t('general.downloadXML') }}
              </v-btn>
            </div>
            <v-btn color="primary darken-1" round flat @click="closeItem">
              {{ $t('general.close') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'expensesPayableComponent',
  data() {
    const today = new Date().toISOString().slice(0, 10)
    return {
      expensePayableErpExportLogSearch: '',
      expensePayableOthersSearch: '',
      searchExpensesId: 0,
      // <!-- CHECK ALL -->
      expensesIds: [],
      allChecked: false,
      tagSelected: 0,
      nameInput: this.$t('general.generateLayoutERP'),
      hiddenDownloadLayout: true,
      hiddenPayGenerateLayout: true,
      hiddenCheck: true,
      expensePayableSearch: '',
      userLogged: {},
      payComplete: false,
      disabled: false,
      menu: false,
      menu2: false,
      errors: {},
      expand: false,
      pagination: {
        sortBy: 'date_sent',
        descending: true,
        page: 1,
        rowsPerPage: 15, // -1 for All",
        totalItems: 0,
      },
      dialog: false,
      dialogPayment: false,
      itemDialog: false,
      valid: true,
      expenses: [],
      expensesOthers: [],
      expenseItem: {
        gst_categories: {
          name: '',
        },
        country: {
          descripcion: '',
        },
        currency: {
          descripcion: '',
          c_Moneda: '',
        },
        sat_forma_pago: {
          descripcion: '',
        },
      },
      editedItem: {
        payment: null,
      },
      loading: false,
      loadingItems: true,
      loadingXML: false,
      approbed: {
        user: {},
      },
      dialogApprobed: false,
      approvers: [],
      typeLayout: null,
      payExpensesByCheck: false,
      dialogPayMultipleExpenses: false,
      loadingDownload: false, 
      viewSelectedExpense: true,
      expensesExportLayout: [],
      dialogDownloadLayoutByExpense: false,
      settings: [],
      currencyHeaders: '',
      satMoneda: [],
      categories: [],
      satFormaPago: [],
      satPais: [],
      menuP: false,
      menuP2: false,
      startDate: new Date(new Date().setMonth(new Date().getMonth() - 3)).toISOString().slice(0, 10),
      endDate: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).toISOString().slice(0, 10),
      maxEndDate: today,
      today,
      loadingDataTable: false,
      loadingDataTableOthers: false,
      loadingDataTableLayout: false,
    }
  },
  computed: {
    applyFeatures(){
      if(this.$store.state.userLogged.company === undefined){
        return false
      }

      if(this.$store.state.userLogged.company[0].features.find(x => x.name === 'PAYABLE_EXPENSES_LAYOUT_BANK')){
        return true
      }

      return false
    },
    applyFeaturesBtnERP(){
      if(this.$store.state.userLogged.company === undefined){
        return false
      }

      if(this.$store.state.userLogged.company[0].features.find(x => x.name === 'PAYABLE_EXPENSES_LAYOUT_ERP')){
        return true
      }

      return false
    },
    applyFeaturesBtnHelperXml(){
      if(this.$store.state.userLogged.company === undefined){
        return false
      }

      if(this.$store.state.userLogged.company[0].features.find(x => x.name === 'PAYABLE_EXPENSES_AUX_XML')){
        return true
      }

      return false
    },
    heading() {
      return this.$t('general.payable')
    },
    subheading() {
      return ''
    },
    icon() {
      return 'fas fa-money-check-alt fa-fw icon-color'
    },
    headers() {
      return [
        {
          text: '#',
          align: 'center',
          sortable: true,
          value: 'id',
        },
        {
          text: this.$t('general.employee'),
          align: 'center',
          value: 'user.name',
          sortable: true,
        },
        {
          text: this.$t('general.description'),
          align: 'center',
          value: 'description',
          sortable: true,
        },
        {
          text: this.$t('general.project'),
          align: 'center',
          value: 'project.name',
          sortable: true,
        },
        {
          text: this.$t('setting.st.period'),
          align: 'center',
          value: 'start_date',
          sortable: true,
        },
        {
          text: this.$t('restriction.rt.amount') + ' ' + this.currencyHeaders,
          align: 'center',
          value: 'repay_back',
          sortable: true,
        },
        {
          text: this.$t('general.advance'),
          align: 'center',
          value: 'advance',
          sortable: true,
        },
        {
          text: this.$t('general.total') + ' ' + this.currencyHeaders,
          align: 'center',
          value: 'total_items.sumtotal_mxn',
          sortable: true,
        },
        {
          text: this.$t('general.pay'),
          align: 'center',
          value: 'items.actions',
          sortable: true,
        },
      ]
    },
    rules() {
      return this.$validationRules()
    },
    viewBtnOthers (){
      if(this.approvers.length <= 1) return false
      
      let filtreApproverByCompany = this.approvers.filter((item) => item.users[0].company[0].id === this.userLogged.company[0].id)

      let isApprover = filtreApproverByCompany.find(x => x.user_id == this.userLogged.id)

      if(isApprover && isApprover.is_default === 1) return false
      
      return true
    },
    tagMoneda() {
      if(!this.settings || this.settings.length === 0) return ''

      const foundCurrencySetting = this.settings.find(x => x.setting_type.name == "st.currency" && x.company_id == this.$store.state.userLogged.company[0].id)
     
      let currencySetting = foundCurrencySetting ? foundCurrencySetting : { value: { c_Moneda: 'MXN' } }

      this.currencyHeaders = currencySetting.value.c_Moneda

      return currencySetting.value.c_Moneda
    },
  },
  watch: {
    dialog(val) {
      val || this.close()
    },
    '$store.state.userLogged'() {
      this.userLogged = this.$store.state.userLogged
      this.getApprovers()
    },
    userLogged() {
      if (this.$store.state.userLogged.company) {
        this.reloadGet()
      }
    },
    payComplete() {
      if (this.payComplete === true) {
        this.editedItem.payment = this.toPay(this.approbed)
        this.disabled = true
      } else if (this.payComplete === false) {
        this.editedItem.payment = null
        this.disabled = false
      }
    },
  },
  created() {
    this.userLogged = this.$store.state.userLogged
    this.getApprovers()
  },
  methods: {
    searchByExpensesId() {
       this.getExpensesPayable()
    },
    searchByDates() {
      this.searchExpensesId = 0
      this.getExpensesPayable()
    },
    getDateMonthsFrom(date, offset) {
      const d = new Date(date);
      d.setMonth(d.getMonth() + offset);
      return d.toISOString().slice(0, 10);
    },
    limiteRangeDay() {
      if (!this.startDate) return;

      const fourMonthsLater = this.getDateMonthsFrom(this.startDate, 4);
      
      this.maxEndDate = fourMonthsLater > this.today ? this.today : fourMonthsLater;
      
      if(fourMonthsLater < this.today) this.showNotification(this.$t('general.updateEndDate'), 'error', -1)

      this.endDate = this.maxEndDate;
    },
    limiteRangeDayEndDate() {
      if (!this.endDate) return;

      const end = new Date(this.endDate);

      const limitStart = new Date(end);

      limitStart.setMonth(limitStart.getMonth() - 4);

      const start = new Date(this.startDate);

      if (start < limitStart) {
        this.showNotification(this.$t('general.updateStartDate'), 'error', -1) 
        this.startDate = limitStart.toISOString().slice(0, 10);
      }
    },
    getExpensesPayable() {
      this.loadingDataTable = true
      this.loadingDataTableOthers = true
      this.loadingDataTableLayout = true
      this.expensesExportLayout = []
      this.$emit('get', { context: this, company: this.userLogged.company[0].id})
      this.$emit('getOthers', { context: this, company: this.userLogged.company[0].id})
    },
    getTotalAmountByExpense(item) {
      return Number(item.subtotal) * Number(item.exchange)
    },
    currencyTag(value) {
      return this.satMoneda.find((element) => element.id === value).c_Moneda
    },
    getCategory(value) {
      return this.categories.find((element) => element.id === value).name
    },
    getPaymentMethod(value) {
      return this.satFormaPago.find((element) => element.id === value).descripcion
    },
    getCountry(value) {
      return this.satPais.find((element) => element.id === value).descripcion
    },
    dialogDownloadLayoutByExpenseM(){
      this.dialogDownloadLayoutByExpense = true
    },
    downloadLayoutByExpense(){
      this.emitDownloadLayout(this.expensesIds)
    },
    remove (item) {
      if (this.expensesIds.length > 0) {
        let expensesIds = this.expensesIds
        expensesIds.splice(expensesIds.indexOf(item), 1)
        expensesIds = [...expensesIds]
      }
    },
    handlePaste(event) {
      const pastedText = event.clipboardData.getData('text');
     
      const values = pastedText.split(/[\s,]+/).map(v => v.trim()).filter(v => v.length)
      
      this.validateIdExpensesLayout(values)
    },
    validateIdExpensesLayout(values){
      const validCodes = [];
      const invalidCodes = [];

      values.forEach(code => {
        if (/^\d+$/.test(code)) { validCodes.push(code) } 
        else { invalidCodes.push(code) }
      })

      this.expensesIds = [ ...new Set([...this.expensesIds, ...validCodes]) ]

      if (invalidCodes.length > 0) this.showNotification(this.$t('general.invalidCodesMessage', { codes: invalidCodes.join(', ') }), 'error', -1) // this.showNotification('error', this.$t('general.invalidCodesMessage', { codes: invalidCodes.join(', ') }))

      this.$nextTick(() => { this.$refs.combo.searchValue = '' })
    },
    handleEnter() {
      const lastItem = this.expensesIds[this.expensesIds.length -1]
      
      this.expensesIds.pop()

      const values = lastItem.split(/[\s,]+/).map(v => v.trim()).filter(v => v.length)

      this.validateIdExpensesLayout(values)
    },
    reloadGet() {
      this.loadingDataTable = true
      this.loadingDataTableOthers = true
      this.loadingDataTableLayout = true
      this.$emit('get', { context: this, company: this.userLogged.company[0].id, })
      this.$emit('getOthers', { context: this, company: this.userLogged.company[0].id, })
      this.$emit('getComplement', { context: this, company: this.userLogged.company[0].id, })
    },
    toggleItem(item, tag) {
      item.isChecked = !item.isChecked
      this.checkAllChecked(tag)
    },
    checkAllChecked(tag){
      this.handleCheckboxChange()
      if(tag === 'expenses') return this.allChecked = this.expenses.every(item => item.isChecked)
      if(tag === 'expensesExportLayout') return this.allChecked = this.expensesExportLayout.every(item => item.isChecked)
      return this.allChecked = this.expensesOthers.every(item => item.isChecked)
    },
    toggleAll(type, value) {
      switch (type) {
        case 'expenses':
          this.expenses.slice(0, 30).forEach(element => {
            this.$set(element, 'isChecked', !this.allChecked)
            this.$forceUpdate()      
          })
          break
        case 'expensesExportLayout':
          this.expensesExportLayout.slice(0, 30).forEach(element => {
            this.$set(element, 'isChecked', !this.allChecked)
            this.$forceUpdate()      
          })
          break
        case 'expensesOthers':
        this.expensesOthers.slice(0, 30).forEach(element => {
            this.$set(element, 'isChecked', !this.allChecked)
            this.$forceUpdate()      
          })
          break
      }
      this.checkAllChecked(type)
    },
    handleTabChange(event){
      this.allChecked = false
      this.hiddenDownloadLayout = true
      this.emptySelected()
      
      switch (event) {
        case 'myApprovals': this.tagSelected = 0; break
        case 'others': this.tagSelected = 1; break
        case 'erpExportLog': this.tagSelected = 2; break
      }
    },
    emptySelected(){      
      let expense = []
      
      switch (this.tagSelected) {
        case 0: expense = this.expenses; break
        case 1: expense = this.expensesOthers; break
        case 2: expense = this.expensesExportLayout; break
      }

      this.allChecked === false
      
      if(!expense || expense.length === 0) return

      expense.forEach(element => {
        this.$set(element, 'isChecked', false)
        this.$forceUpdate()      
      })
    },
    getApprovers(){
      if(this.approvers.length === 0 && this.$store.state.userLogged){
        this.$emit('getApprovers', {
          context: this
        })
      }
    },
    handleCheckboxChange() {
      let checkExpense = this.expenseChecked()
      
      if(checkExpense == undefined) return this.hiddenBtnLayout(true, true)
      
      if(this.payExpensesByCheck) return this.hiddenBtnLayout(true, checkExpense.length > 0) 
      
      this.hiddenBtnLayout(checkExpense.length > 0, true)
    },
    hiddenBtnLayout(downloadLayout, payDownloadLayout){
      this.hiddenDownloadLayout = downloadLayout
      this.hiddenPayGenerateLayout = payDownloadLayout
    },
    expenseChecked(){
      return this.tagSelected === 0 
           ? this.expenses.find(x => x.isChecked == true)
           : this.tagSelected === 1 ? this.expensesOthers.find(x => x.isChecked == true) 
           : this.expensesExportLayout.find(x => x.isChecked == true)
    },
    downloadLayout() {
      this.loadingDownload = true

      let downloadLayout =this.getExpensesChecked()
      
      this.emitDownloadLayout(downloadLayout.map(obj => obj.id))
    },
    emitDownloadLayout(listId) {
      let urlDownload = this.getFeatureDownload()
      
      this.$emit('downloadLayout', {
          listId: listId,
          url: urlDownload.pivot.param1,
          typeArchive: urlDownload.pivot.param2,
          context: this,
        })
    },
    getFeatureDownload(){
      switch (this.typeLayout) {
        case 'PAYABLE_EXPENSES_LAYOUT_BANK':
          return this.$store.state.userLogged.company[0].features.find(x => x.name === 'PAYABLE_EXPENSES_LAYOUT_BANK')
        case 'PAYABLE_EXPENSES_LAYOUT_ERP':
          return this.$store.state.userLogged.company[0].features.find(x => x.name === 'PAYABLE_EXPENSES_LAYOUT_ERP')
        case 'PAYABLE_EXPENSES_AUX_XML':
          return this.$store.state.userLogged.company[0].features.find(x => x.name === 'PAYABLE_EXPENSES_AUX_XML')
        default:
          return this.$store.state.userLogged.company[0].features.find(x => x.name === 'PAYABLE_EXPENSES_LAYOUT_ERP')
      }
    },
    createLayout(){
      this.typeLayout = 'PAYABLE_EXPENSES_LAYOUT_BANK'
      let itemSelected = this.expenses.find(item => item.isChecked == true)
      this.hiddenCheck = false
    },
    createLayoutERP(input){
      this.typeLayout = 'PAYABLE_EXPENSES_LAYOUT_ERP'
      this.hiddenCheck = false
      this.payExpensesByCheck = input === 1 ? false : true 
      this.nameInput = input === 1 ? this.$t('general.generateLayoutERP') : this.$t('general.payGenerateLayout')
      this.handleCheckboxChange()
    },
    getExpensesChecked(){
      return this.tagSelected === 0
            ? this.expenses.filter(x => x.isChecked == true)
            : this.tagSelected === 1 ? this.expensesOthers.filter(x => x.isChecked == true) 
            : this.expensesExportLayout.filter(x => x.isChecked == true)
    },
    payMultipleExpenses(){
      let expensesChecked = this.getExpensesChecked()
      this.downloadLayout()
      
      if(expensesChecked && expensesChecked.length >= 30) return this.showNotification(this.$t('general.max30Data'), 'error', -1) 

      if(expensesChecked.length > 0){
          expensesChecked.forEach(element => {
          let pay = this.toPay(element)
          this.$emit('changeStatus', { payment: pay, expensesId: element.id, context: this})
          this.deleteExpensesPayComplete()
        })
      }
      this.dialogPayMultipleExpenses = false
    },
    deleteExpensesPayComplete(){
      //AQUI ELIMINA EL REGISTRO
      const expensesPayCompleted = this.getExpensesChecked()
      if(expensesPayCompleted.length > 0){
        expensesPayCompleted.forEach(expense => {
          this.expenses = this.expenses.filter(elemento => elemento.id !== expense.id)
          this.expensesOthers = this.expensesOthers.filter(elemento => elemento.id !== expense.id)
        });
        
      }
    },
    //SE PUEDE GENERAR UN COMÚN PARA LAS DESCARGAS A TRAVES DE UN TYPE_LAYOUT
    createLayoutHelperXml(){
      this.typeLayout = 'PAYABLE_EXPENSES_AUX_XML'
      let itemSelected = this.expenses.find(item => item.isChecked == true)
      this.hiddenCheck = false
    },
    downloadXML() {
      this.loadingXML = true
      this.$store.dispatch('downloadXML', {
        event: {
          context: this,
          fileId: this.expenseItem.gst_expenses_items_files[0].files_id,
          description: this.expenseItem.description,
        },
      })
    },
    changeSort(header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
    },
    payback(item) {
      if (item > 0) {
        return this.$t('general.payment')
      } else if (item < 0) {
        return this.$t('general.refund')
      } else {
        return this.$t('general.noHave')
      }
    },
    toPay(item) {
      if (item.payments !== undefined && item.payments.length > 0) {
        let payments = 0
        for (let i = 0; i < item.payments.length; i++) {
          const element = item.payments[i]
          payments += parseFloat(element.amount)
        }
        return item.is_blue_voucher ? (Math.abs(item.voucher_amount) - payments).toFixed(2) :  (Math.abs(item.repay_back) - payments).toFixed(2)
      } else {
        return item.is_blue_voucher ? Math.abs(item.voucher_amount)  : Math.abs(item.repay_back)
      }
    },
    itemExpenseDialog(item) {
      this.expenseItem = Object.assign({}, item)
      this.expenseItem.category = this.getCategory(this.expenseItem.gst_categories_id)
      this.expenseItem.paymentMethod = this.getPaymentMethod(this.expenseItem.sat_formaPago_id)
      this.expenseItem.countryTag = this.getCountry(this.expenseItem.country)
      this.expenseItem.currencyTag = this.currencyTag(this.expenseItem.currency)
      this.itemDialog = true
    },
    closeItem() {
      this.expenseItem = {
        gst_categories: {
          name: '',
        },
        country: {
          descripcion: '',
        },
        currency: {
          descripcion: '',
        },
        sat_forma_pago: {
          descripcion: '',
        },
      }
      this.itemDialog = false
      this.loading = false
    },
    viewNewItemsApprobed(newItemA) {
      this.approbed = Object.assign({}, newItemA)
      this.dialogApprobed = true
    },
    paymentApprove(newItemA) {
      this.approbed = Object.assign({}, newItemA)
      this.dialogPayment = true
    },
    close() {
      this.dialogApprobed = false
      this.dialogPayment = false
      this.payComplete = false
      this.loading = false
      this.disabled = false
      this.editedItem.payment = null
      this.$refs.form.resetValidation()
      this.viewSelectedExpense = true
      this.hiddenCheck = true
      this.dialogDownloadLayoutByExpense = false
      this.expensesIds = []
    },
    payExpenses() {
      if (!this.editedItem.payment || isNaN(this.editedItem.payment) || parseFloat(this.editedItem.payment) === 0) return this.showNotification(this.$t('general.addAmountCorrect'), 'error', -1)
      
      this.errors = {}
      if (this.$refs.form.validate()) {
        this.loading = true
        this.disabled = true
        this.changeStatus()
      }
    },
    changePaid() {
      this.loading = true
      this.$emit('changeStatus', {
        payment: this.approbed.is_blue_voucher ? this.approbed.voucher_amount : Math.abs(this.approbed.repay_back),
        expensesId: this.approbed.id,
        context: this,
      })
    },
    changeStatus() {
      this.$emit('changeStatus', {
        payment: this.editedItem.payment,
        expensesId: this.approbed.id,
        context: this,
      })
    },
    refresh() {
      this.expensesExportLayout = []
      this.$emit('refresh', {
        userLogged: this.userLogged,
        context: this,
      })
    },
    deployRow(props) {
      props.expanded = !props.expanded
    },
  },
}
</script>

<style scoped>
  .checkbox-and-data {
    display: flex;
    align-items: center; 
    justify-content: center;
  }

  .checkbox-and-data text {
    display: flex;
    align-items: center; 
  }
  
  .checkbox-and-data v-checkbox {
    margin-right: 5px; /* Espacio entre el checkbox y el dato */
    margin-bottom: -15px;
  }

  .v-input--selection-controls {
      margin-top: 28px !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/expensesPayable.component.vue